import { KeyValueDefault } from '@/main/models/common';
import { KeyValueDefaultEnum } from '@/main/models/common/keyValueDefaultEnum';
import { getTranslateByKey } from '@/main/services/utils';
import { convertStringForBoolean } from '@/main/services/utilsString';
import z from 'zod';

function getRequiredMessage(fieldKey: string) {
  return getTranslateByKey('information.isRequired', true).replace(
    '{0}',
    getTranslateByKey(fieldKey)
  );
}

const cancelledPartRequoteSchema = z.object({
  partType: z.custom<KeyValueDefault>().nullable()
});

export type ICancelledPartRequoteSchema = z.infer<
  typeof cancelledPartRequoteSchema
>;

export const requotePartsCancelledSchema = z
  .object({
    deadlineAnswer: z.string(),
    reason: z.custom<KeyValueDefaultEnum>().nullable(),
    reasonDescription: z.string().nullable(),
    parts: z.array(cancelledPartRequoteSchema)
  })
  .superRefine((data, ctx) => {
    if (!data.deadlineAnswer.trim()) {
      ctx.addIssue({
        code: 'custom',
        path: ['deadlineAnswer'],
        message: getRequiredMessage('quote.requoteDeadlineAnswer')
      });
    }
    if (!data.reason) {
      ctx.addIssue({
        code: 'custom',
        path: ['reason'],
        message: getRequiredMessage('information.reason')
      });
    }
    if (
      data.reason &&
      convertStringForBoolean(data.reason.default) &&
      !data.reasonDescription?.trim()
    ) {
      ctx.addIssue({
        code: 'custom',
        path: ['reasonDescription'],
        message: getRequiredMessage('information.description')
      });
    }
  });

export type RequoteCancelledPartsForm = z.infer<
  typeof requotePartsCancelledSchema
>;

export const INITIAL_VALUES_FORM_REQUOTE: RequoteCancelledPartsForm = {
  deadlineAnswer: '',
  parts: [],
  reason: null,
  reasonDescription: null
};
